import React from "react";
import { NavLink } from "react-router-dom";

export default function ITServices() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Comprehensive IT Services</h1>
            <h5 className="text-muted">
              Reliable, Scalable & Smart IT Infrastructure for Business Success
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/it-support-concept-illustration_114360-7298.jpg"
              alt="IT Services"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">End-to-End IT Support for Your Business</h2>
            <p>
              <strong>Bytlas Intelligence</strong> delivers complete IT services to enhance productivity,
              secure digital operations, and streamline your technology environment — whether on-premise, 
              in the cloud, or hybrid.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ IT Infrastructure Design & Deployment</li>
              <li className="list-group-item">✅ Cloud Solutions (AWS, Azure, Google)</li>
              <li className="list-group-item">✅ Network & Server Management</li>
              <li className="list-group-item">✅ Helpdesk & Technical Support Services</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Modern IT Infrastructure</h3>
            <p>
              From procurement to setup and support — we handle everything your IT environment needs.
              We ensure security, efficiency, and scalability across your organization.
            </p>
            <ul>
              <li>🖥️ Hardware & Software Solutions</li>
              <li>☁️ Cloud Migration & Management</li>
              <li>🛠️ System Administration & Monitoring</li>
              <li>🧑‍💼 Virtualization & Remote Access Setup</li>
            </ul>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Managed IT Services</h3>
            <p>
              Let our experts manage your IT operations while you focus on growth. Our managed services 
              provide proactive support, timely updates, and 24x7 system health monitoring.
            </p>
            <ul>
              <li>🔧 Routine Maintenance & Troubleshooting</li>
              <li>📡 Network Security & Firewall Configuration</li>
              <li>🔒 Endpoint Protection & Backup</li>
              <li>📞 Remote & On-site Technical Assistance</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Request a Free IT Assessment
          </NavLink>
        </div>
      </div>
    </section>
  );
}
